import { ThemeProvider } from "styled-components";
import theme from "theme";
import {
  TooltipMenu,
  HeaderPanel,
  ScrollableContentPanel,
  ListPanel,
  Title,
  PanelContent,
  ItemList,
} from "./styles";

const ProductTooltip = ({ listStyle, product, catalog }) => {
  const productHasWorkbooks = Object.keys(catalog[product.id]).includes("bi");
  const productHasViews = Object.keys(catalog[product.id]).includes("data");

  return (
    <ThemeProvider theme={theme}>
      <ScrollableContentPanel style={{ minWidth: "300px", maxHeight: "50vh" }}>
        <TooltipMenu>
          <HeaderPanel>
            <Title>Description:</Title>
            <div style={{ textAlign: "justify" }}>
              {product.meta.description}
            </div>
          </HeaderPanel>

          {(productHasWorkbooks || productHasViews) && (
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                gap: "12px",
              }}
            >
              {productHasWorkbooks && (
                <ListPanel>
                  <Title>Included Workbooks: </Title>
                  <PanelContent>
                    <ItemList>
                      {Object.values(catalog[product.id].bi.workbooks).map(
                        (workbook) => (
                          <li key={workbook.id} style={{ ...listStyle }}>
                            {workbook.id}
                          </li>
                        )
                      )}
                    </ItemList>
                  </PanelContent>
                </ListPanel>
              )}
              {productHasViews && (
                <ListPanel>
                  <Title>Included Views: </Title>
                  <PanelContent>
                    <ItemList>
                      {Object.values(catalog[product.id]?.data).map((view) => (
                        <li key={view.id} style={{ ...listStyle }}>
                          {view.id}
                        </li>
                      ))}
                    </ItemList>
                  </PanelContent>
                </ListPanel>
              )}
            </div>
          )}
        </TooltipMenu>
      </ScrollableContentPanel>
    </ThemeProvider>
  );
};

export default ProductTooltip;
